import i18n from '../../utils/i18n';

export const OP_VALUES_TABLE_COLS = [
	{
		key: 'label',
		numeric: false,
		sortable: true,
		label: i18n.t('components.opValues.constants.columns.name'),
		unit: ''
	},
	{
		key: 'value',
		numeric: false,
		sortable: false,
		label: i18n.t('components.opValues.constants.columns.value'),
		unit: ''
	},
	{
		key: 'description',
		numeric: false,
		sortable: false,
		label: i18n.t('components.opValues.constants.columns.description'),
		unit: ''
	}
];

export const OP_VALUES_CSV_HEADER = [
	{
		key: 'label',
		label: i18n.t('components.opValues.constants.columns.name')
	},
	{
		key: 'value',
		label: i18n.t('components.opValues.constants.columns.value')
	},
	{
		key: 'description',
		label: i18n.t('components.opValues.constants.columns.description')
	}
];

/* The order of OP_VALUES_CATEGORIES is determined by index value */
export const OP_VALUES_CATEGORIES = {
	ALL: {
		index: 0,
		label: i18n.t('components.opValues.constants.categories.all')
	},
	SYSTEM_INFO: {
		index: 1,
		label: i18n.t('components.opValues.constants.categories.systemInfo')
	},
	IC: {
		index: 2,
		label: i18n.t('components.opValues.constants.categories.ic')
	},
	THERMAL: {
		index: 3,
		label: i18n.t('components.opValues.constants.categories.thermal')
	},
	MOSFET: {
		index: 4,
		label: i18n.t('components.opValues.constants.categories.mosfet')
	},
	CAPACITOR: {
		index: 5,
		label: i18n.t('components.opValues.constants.categories.capacitor')
	},
	DIODE: {
		index: 6,
		label: i18n.t('components.opValues.constants.categories.diode')
	},
	INDUCTOR: {
		index: 7,
		label: i18n.t('components.opValues.constants.categories.inductor')
	},
	RESISTOR: {
		index: 8,
		label: i18n.t('components.opValues.constants.categories.resistor')
	},
	SNUBBER: {
		index: 9,
		label: i18n.t('components.opValues.constants.categories.snubber')
	},
	TRANSFORMER: {
		index: 10,
		label: i18n.t('components.opValues.constants.categories.transformer')
	},
	POWER: {
		index: 11,
		label: i18n.t('components.opValues.constants.categories.power')
	},
	CURRENTS: {
		index: 12,
		label: i18n.t('components.opValues.constants.categories.currents')
	}
};

/* The order of OP_VALUES is determined by index value */
export const OP_VALUES = {
	/* SYSTEM INFO */
	ConductionMode: {
		index: 0,
		label: i18n.t('components.opValues.constants.names.condMode'),
		description: {
			CCM: i18n.t('components.opValues.constants.descriptions.conductionMode.ccm'),
			FCCM: i18n.t('components.opValues.constants.descriptions.conductionMode.fccm'),
			DCM: i18n.t('components.opValues.constants.descriptions.conductionMode.dcm')
		}
	},
	Configuration_ChargePump: {
		index: 5,
		label: i18n.t('components.opValues.constants.names.chpConfig'),
		description: {
			InvertingTripler: i18n.t('components.opValues.constants.descriptions.chpConfig.invertingTripler'),
			InvertingDoubler: i18n.t('components.opValues.constants.descriptions.chpConfig.invertingDoubler'),
			Inverter: i18n.t('components.opValues.constants.descriptions.chpConfig.inverter'),
			Doubler: i18n.t('components.opValues.constants.descriptions.chpConfig.doubler'),
			Tripler: i18n.t('components.opValues.constants.descriptions.chpConfig.tripler')
		}
	},
	DutyCycle: {
		index: 10,
		label: 'D',
		description: i18n.t('components.opValues.constants.descriptions.dutyCycle')
	},
	Efficiency: {
		index: 20,
		label: 'η',
		description: i18n.t('components.opValues.constants.descriptions.efficiency')
	},
	Frequency: {
		index: 30,
		label: 'f',
		description: i18n.t('components.opValues.constants.descriptions.frequency')
	},
	Vin: {
		index: 40,
		label: 'V<sub>IN</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vin')
	},
	Vin_AC: {
		index: 41,
		label: 'V<sub>IN(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vinAc')
	},
	Vcc: {
		index: 42,
		label: 'V<sub>CC</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vcc')
	},
	Iin: {
		index: 50,
		label: 'I<sub>IN(avg)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.iin')
	},
	Iin_AC: {
		index: 51,
		label: 'I<sub>IN(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.iinAc')
	},
	Vout: {
		index: 60,
		label: 'V<sub>OUT</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vout')
	},
	Vout_Actual: {
		index: 61,
		label: 'V<sub>OUT(actual)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.voutActual')
	},
	Vout_Peak_2_Peak: {
		index: 62,
		label: 'V<sub>OUT(pp)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.voutPeak2Peak')
	},
	VinTarget_ChargePump: {
		index: 63,
		label: 'V<sub>IN(target)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vinTargetChP')
	},
	VoutActual_Min_ChargePump: {
		index: 64,
		label: 'V<sub>OUT(actual min)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.voutActualMinChP')
	},
	VoutActual_Max_ChargePump: {
		index: 65,
		label: 'V<sub>OUT(actual max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.voutActualMaxChP')
	},
	RippleVoltage_Vout: {
		index: 66,
		label: 'V<sub>OUT(ripple)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rippleVoltageVout')
	},
	VfwDiodeDrop_ChargePump: {
		index: 67,
		label: 'V<sub>FW</sub>',
		description: i18n.t('components.opValues.constants.descriptions.vfwDiodeDropChP')
	},
	PdissQuiescentCurrent_IC_ChargePump: {
		index: 68,
		label: 'P<sub>IQ</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissQuiescentCurrICChP')
	},
	Iout: {
		index: 70,
		label: 'I<sub>OUT</sub>',
		description: i18n.t('components.opValues.constants.descriptions.iout')
	},
	Pout: {
		index: 72,
		label: 'P<sub>OUT</sub>',
		description: i18n.t('components.opValues.constants.descriptions.pout')
	},
	LineFrequency: {
		index: 73,
		label: 'f<sub>line</sub>',
		description: i18n.t('components.opValues.constants.descriptions.lineFrequency')
	},
	/* IC */
	IcTj: {
		index: 81,
		label: 'T<sub>j</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IcTj')
	},
	TjMax: {
		index: 82,
		label: 'T<sub>j(max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.TjMax')
	},
	ICThetaJAEffective: {
		index: 83,
		label: 'Θ<sub>ja</sub>',
		description: i18n.t('components.opValues.constants.descriptions.ICThetaJAEffective')
	},
	Ic_Pdiss: {
		index: 84,
		label: 'P<sub>\u03A3</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IcPdiss')
	},
	PdissLinear_ldo: {
		index: 85,
		label: 'P<sub>LIN</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissLinearLdo')
	},
	PdissGround_ldo: {
		index: 86,
		label: 'P<sub>GND</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissGroundLdo')
	},
	Pdiss_quiescentCurrent_IC: {
		index: 87,
		label: 'P<sub>Q</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissquiescentCurrIC')
	},
	PdissBias_ldo: {
		index: 88,
		label: 'P<sub>cc</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissBiasLdo')
	},
	PdissDisable_ldo: {
		index: 89,
		label: 'P<sub>dis</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissDisableLdo')
	},
	PdissTotal_ICfb: {
		index: 90,
		label: 'P<sub>opto</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalICfb')
	},
	IgroundAtMaxICIout: {
		index: 95,
		label: 'I<sub>GND(max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IgroundAtMaxICIout')
	},
	IgroundAtMaxIout_ldo: {
		index: 101,
		label: 'I<sub>GND</sub>@I<sub>OUT(max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IgroundAtMaxIoutLdo')
	},
	Iquiescent_ldo: {
		index: 103,
		label: 'I<sub>Q</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IquescientLdo')
	},
	Vbias_ldo: {
		index: 105,
		label: 'V<sub>CC</sub>',
		description: i18n.t('components.opValues.constants.descriptions.VbiasLdo')
	},
	Ibias_ldo: {
		index: 107,
		label: 'I<sub>CC</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IbiasLdo')
	},
	Ibias: {
		index: 108,
		label: 'I<sub>CC</sub>',
		description: i18n.t('components.opValues.constants.descriptions.Ibias')
	},
	Idisable_ldo: {
		index: 109,
		label: 'I<sub>DIS</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IdisableLdo')
	},
	Iadjust_ldo: {
		index: 111,
		label: 'I<sub>ADJ</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IadjustLdo')
	},
	IadjPin_ldo: {
		index: 112,
		label: 'I<sub>ADJ</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IadjPinLdo')
	},
	VrefTyp_ldo: {
		index: 113,
		label: 'V<sub>REF(typ)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.VrefTypLdo')
	},
	psrr_ldo: {
		index: 115,
		label: 'PSRR',
		description: i18n.t('components.opValues.constants.descriptions.psrrLdo')
	},
	VdoMax_ldo: {
		index: 116,
		label: 'V<sub>DO(max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.VdoMaxLdo')
	},
	VccMin: {
		index: 117,
		label: 'V<sub>CC(min)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.VccMin')
	},
	/* THERMAL */
	ThetaJAEffective: {
		index: 600,
		label: '\u0398<sub>JA</sub>',
		description:
			i18n.t('components.opValues.constants.descriptions.thetaJAEffective') +
			' <a href="https://www.onsemi.com/pub/Collateral/AND8222-D.PDF" target="_blank" style="text-decoration: none; color:#006993">AND8222/D</a>'
	},
	ThetaJC: {
		index: 601,
		label: '\u0398<sub>JC</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thetaJC')
	},
	AreaPCB: {
		index: 602,
		label: 'A<sub>PCB</sub>',
		description: i18n.t('components.opValues.constants.descriptions.areaPCB')
	},
	AreaCu: {
		index: 603,
		label: 'A<sub>Cu</sub>',
		description: i18n.t('components.opValues.constants.descriptions.areaCu')
	},
	ViaCount: {
		index: 604,
		label: 'Via count',
		description: i18n.t('components.opValues.constants.descriptions.viaCount') + ' \u00B5m'
	},
	ViaPitch: {
		index: 605,
		label: 'Via pitch',
		description: i18n.t('components.opValues.constants.descriptions.viaPitch')
	},
	ThickCuIn: {
		index: 606,
		label: 't<sub>Cu(IN)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thickCuIn')
	},
	ThickCuOut: {
		index: 607,
		label: 't<sub>Cu(OUT)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thickCuOut')
	},
	ThickCore: {
		index: 608,
		label: 't<sub>core</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thickCore')
	},
	ThickPrepreg: {
		index: 609,
		label: 't<sub>prepreg</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thickPrepreg')
	},
	ThickPCB: {
		index: 610,
		label: 't<sub>PCB</sub>',
		description: i18n.t('components.opValues.constants.descriptions.thickPCB')
	},
	CondInsul: {
		index: 611,
		label: 'k<sub>PCB</sub>',
		description: i18n.t('components.opValues.constants.descriptions.condInsul')
	},
	CondCu: {
		index: 612,
		label: 'k<sub>Cu</sub>',
		description: i18n.t('components.opValues.constants.descriptions.condCu')
	},
	/* MOSFET single*/
	PdissConduction_Mosfet: {
		index: 800,
		label: 'P<sub>COND(FET RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissConductionM')
	},
	RmsCurrent_Mosfet: {
		index: 810,
		label: 'I<sub>FET(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rmsCurrM')
	},
	Tj_Mosfet: {
		index: 820,
		label: 'T<sub>j(FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.TjM')
	},
	/* MOSFET HS */
	MosfetHS_Tj: {
		index: 160,
		label: 'T<sub>j(HS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.MHSTj')
	},
	Pdiss_total_MosfetHS: {
		index: 170,
		label: 'P<sub>\u03A3(HS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalMHS')
	},
	Pdiss_conduction_MosfetHS: {
		index: 180,
		label: 'P<sub>COND(HS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissConductionMHS')
	},
	Pdiss_switching_MosfetHS: {
		index: 190,
		label: 'P<sub>SWITCH(HS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissSwitchingMHS')
	},
	RmsCurrent_MosfetHS: {
		index: 230,
		label: 'I<sub>HS-FET(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rmsCurrMHS')
	},
	/* MOSFET LS */
	MosfetLS_Tj: {
		index: 240,
		label: 'T<sub>j(LS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.MLSTj')
	},
	Pdiss_total_MosfetLS: {
		index: 250,
		label: 'P<sub>\u03A3(LS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalMLS')
	},
	Pdiss_conduction_MosfetLS: {
		index: 260,
		label: 'P<sub>COND(LS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissConductionMLS')
	},
	Pdiss_switching_MosfetLS: {
		index: 270,
		label: 'P<sub>SWITCH(LS-FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissSwitchingMLS')
	},
	RmsCurrent_MosfetLS: {
		index: 300,
		label: 'I<sub>LS-FET(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rmsCurrMLS')
	},
	/* MOSFET pair */
	PdissTotalConduction_Mosfet: {
		index: 700,
		label: 'P<sub>COND(FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalConductionM')
	},
	PdissTotalSwitching_Mosfet: {
		index: 710,
		label: 'P<sub>SWITCH(FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalSwitchingM')
	},
	PdissTotal_Mosfet: {
		index: 720,
		label: 'P<sub>\u03A3(FET)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalM')
	},
	/* CAPACITOR */
	CinPdiss: {
		index: 310,
		label: 'P<sub>C(IN)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.cinPdiss')
	},
	RmsCurrent_Cin: {
		index: 311,
		label: 'I<sub>C(IN RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rmsCurrCin')
	},
	CdcPdiss: {
		index: 312,
		label: 'P<sub>C(DC)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.cdcPdiss')
	},
	RmsCurrent_Cdc: {
		index: 313,
		label: 'I<sub>C(DC RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rmsCurrCdc')
	},
	CoutPdiss: {
		index: 320,
		label: 'P<sub>C(OUT)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.coutPdiss')
	},
	CoutIrms: {
		index: 330,
		label: 'I<sub>C(OUT RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.coutIrms')
	},
	Snubber_Capacitor_Pdiss: {
		index: 331,
		label: 'P<sub>C(SN)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.snubberCapacitorPdiss')
	},
	Snubber_Capacitor_Rms_Current: {
		index: 332,
		label: 'I<sub>C(SN RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.snubberCapacitorRmsCurr')
	},
	/* DIODE */
	Diode_Tj: {
		index: 340,
		label: 'T<sub>j(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.diodeTj')
	},
	Rthja_D: {
		index: 341,
		label: 'Θ<sub>ja(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rthjaD')
	},
	Pdiss_total_Diode: {
		index: 350,
		label: 'P<sub>\u03A3(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalDiode')
	},
	Pdiss_conduction_Diode: {
		index: 360,
		label: 'P<sub>COND(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissConductionDiode')
	},
	/* Pdiss_switching_Diode: {
        index: 370,
        label: 'Diode switching Pdiss',
        description: i18n.t('components.opValues.constants.descriptions.PdissSwitchingDiode'),
    }, */
	Pdiss_leakage_Diode: {
		index: 380,
		label: 'P<sub>leak(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissLeakageDiode')
	},
	Pdiss_reverseRecovery_Diode: {
		index: 390,
		label: 'P<sub>RR(D)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissReverseRecoveryDiode')
	},
	Input_Diode_Rectifier_junction_temperature: {
		index: 391,
		label: 'T<sub>j(D-Bridge)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IDRJTemp')
	},
	Rthja_input_Diode: {
		index: 392,
		label: 'Θ<sub>ja(D-Bridge)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rthjaInputDiode')
	},
	Input_Diode_Rectifier_Pdiss: {
		index: 393,
		label: 'P<sub>D Bridge</sub>',
		description: i18n.t('components.opValues.constants.descriptions.IDRPdiss')
	},
	Snubber_Diode_junction_temperature: {
		index: 394,
		label: 'T<sub>j(D-SNUB)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.snubberDiodeJunctionTemp')
	},
	Snubber_Diode_Pdiss: {
		index: 395,
		label: 'P<sub>D(SNUB)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.snubberDiodePdiss')
	},
	Rthja_subber_Diode: {
		index: 396,
		label: 'Θ<sub>j(D-SNUB)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.rthjaSubberDiode')
	},
	/* INDUCTOR */
	LIpp: {
		index: 400,
		label: 'I<sub>L(pp)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LIpp')
	},
	IppPercentage: {
		index: 410,
		label: 'I<sub>L(%)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.ippPercentage')
	},
	LPdiss: {
		index: 420,
		label: 'P<sub>L</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LPDiss')
	},
	LIrms: {
		index: 430,
		label: 'I<sub>L(RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LIrms')
	},
	LImin: {
		index: 440,
		label: 'I<sub>L(min)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LImin')
	},
	LIAvg: {
		index: 450,
		label: 'I<sub>L(avg)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LIAvg')
	},
	LIPeak: {
		index: 460,
		label: 'I<sub>L(max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.LIPeak')
	},
	/* RESISTOR */
	Snubber_Resistor_Pdiss: {
		index: 470,
		label: 'P<sub>R(SNUB)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.snubberResistorPdiss')
	},
	Sensing_Resistor_Pdiss: {
		index: 471,
		label: 'P<sub>R(SENSE)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.sensingResistorPdiss')
	},
	Rtop_operationPointCurrent: {
		index: 480,
		label: 'I<sub>R(TOP)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.RtopOperationPointCurr')
	},
	Rbot_operationPointCurrent: {
		index: 481,
		label: 'I<sub>R(BOTTOM)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.RbotOperationPointCurr')
	},
	Rtop_Pdiss: {
		index: 490,
		label: 'P<sub>R(TOP)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.RtopPdiss')
	},
	Rbot_Pdiss: {
		index: 491,
		label: 'P<sub>R(BOTTOM)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.RbotPdiss')
	},
	/* SNUBBER */
	PdissTotalSnubber: {
		index: 492,
		label: 'P<sub>\u03A3(SNUB)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.PdissTotalSnubber')
	},
	/* TRANSFORMER */
	Transformer_Pdiss: {
		index: 520,
		label: 'P<sub>TR</sub>',
		description: i18n.t('components.opValues.constants.descriptions.transformerPdiss')
	},
	Primary_Rms_Current: {
		index: 530,
		label: 'I<sub>TR(Pr RMS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.primaryRmsCurr')
	},
	Primary_Valley_Current: {
		index: 540,
		label: 'I<sub>TR(Pr min)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.primaryValleyCurr')
	},
	Primary_Peak_Current: {
		index: 550,
		label: 'I<sub>TR(Pr max)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.primaryPeakCurr')
	},
	/* POWER */
	Total_Pdiss: {
		index: 560,
		label: 'P<sub>\u03A3(SYS)</sub>',
		description: i18n.t('components.opValues.constants.descriptions.totalPdiss')
	}
};
